export default __webpack_public_path__ + "fonts/2c4816f5658fc2f192e97025458a23a7.svg";